angular.module('dnecom')
    .controller('StoreProductSearchSettingsController', StoreProductSearchSettingsController);

StoreProductSearchSettingsController.$inject = ['$http', '$scope', 'wizardModal', 'notifications'];

function StoreProductSearchSettingsController($http, $scope, wizardModal, notifications) {
    let vm = this;
    const store = TemplateData.value('store');
    const isAvailableProductSearch = TemplateData.value('isAvailableProductSearch');
    vm.isProductSearchEnabled = !!parseInt(_.get(store, ['properties', 'productSearch', 'isProductSearchEnabled']));
    vm.toggleProductSearch = function () {
        if (!isAvailableProductSearch && !vm.isProductSearchEnabled) {
            wizardModal.open({
                'templateUrl': 'productSearchRequiredModal.html',
                'size': 'md',
                'windowClass': 'modal-danger',
                'controller': function ($scope, $uibModalInstance) {
                    $scope.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            });
            vm.isProductSearchEnabled = false;
            return;
        }

        vm.isProductSearchEnabled = !vm.isProductSearchEnabled;
        $http.post(
            Routing.generate('stores_enable_product_search', { id: store.id }),
            {properties: {productSearch: {'isProductSearchEnabled': !!vm.isProductSearchEnabled}}}
        ).then(function (response) {
            if (!response.data.success) {
                notifications.danger(response.data.message);
                vm.isProductSearchEnabled = !vm.isProductSearchEnabled;
            }
        })
    };
}
